import { Stack, Switch, useTheme } from '@mui/material';
import { Text } from '../Text/Text';
import { toggleSwitchSx } from './ToggleSwitch.style';

export const ToggleSwitch = ({
  leftText,
  rightText,
  handleChange,
  checked,
}) => {
  const theme = useTheme();

  return (
    <Stack direction="row" spacing={1} alignItems="center">
      <Text text={leftText} />
      <Switch
        checked={checked}
        onChange={handleChange}
        sx={toggleSwitchSx(theme)}
      />
      <Text text={rightText} />
    </Stack>
  );
};
